const options: Intl.DateTimeFormatOptions = {
  month: "2-digit",
  day: "2-digit",
  year: "numeric"
};

export const handleConvertDate = (date: Date) => {
  const convertDate: Date = new Date(date);
  return convertDate.toLocaleDateString("no-NO", options);
};
